module.exports = __webpack_public_path__ + "img/firefox-250.02515a21.png";